import { useNavigate } from 'react-router-dom';
import { useGetUserIdentities } from '../../../domains/user/ui/hooks/useGetUserIdentities';
import type { PaymentRequest } from '../../../domain/models/payments/Payment';
import { usePayment } from './usePayment';
import {
  isBillingBuyerInfoComplete,
  loadBillingBuyerInfo
} from '../../../utils/billingBuyerInfoStorage';

interface UseInicisPaymentProps {
  amount: string;
  productName: string;
  productId: string;
}

export const useInicisPayment = ({ amount, productName, productId }: UseInicisPaymentProps) => {
  const navigate = useNavigate();
  const { data: userIdentity, isLoading: isLoadingUserIdentities } = useGetUserIdentities();
  const { generateOrderId, requestPayment } = usePayment();

  const handleCreateOrder = async () => {
    if (!productId) return;
    try {
      const userBuyerInfo = userIdentity
        ? {
            buyerName: userIdentity.name,
            buyerEmail: userIdentity.email,
            buyerTel: userIdentity.phoneNumber
          }
        : null;
      const storedBuyerInfo = loadBillingBuyerInfo();
      const resolvedBuyerInfo = isBillingBuyerInfoComplete(userBuyerInfo)
        ? userBuyerInfo
        : isBillingBuyerInfoComplete(storedBuyerInfo)
          ? storedBuyerInfo
          : null;

      if (!resolvedBuyerInfo) {
        if (!isLoadingUserIdentities) {
          navigate(
            `/payment/buyer-info?amount=${amount}&productName=${productName}&productId=${productId}`
          );
        }
        return;
      }

      // 1) 주문번호 생성 (UseCase)
      const orderId = await generateOrderId(productId);

      // 2) 결제 요청 데이터 구성
      const payload: PaymentRequest = {
        gopaymethod: 'CARD',
        mid: 'myshopif17',
        oid: orderId,
        price: Number(amount),
        goodname: productName,
        buyername: resolvedBuyerInfo.buyerName,
        buyertel: resolvedBuyerInfo.buyerTel,
        buyeremail: resolvedBuyerInfo.buyerEmail
      };

      // 3) 결제 요청 (UseCase 통해 Repository로 위임)
      await requestPayment(payload);
    } catch {
      navigate('/payment/fail');
    }
  };
  return { handleCreateOrder };
};
